import { pick, prop } from 'ramda';
import { useEffect, useState } from 'react';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { getScript, getStylesheet } from 'js/utils/scripts.util';

import { useIsWidgetsEnabled } from './useIsWidgetsEnabled';

// Sun: added script only for user
export const useLoadWidgets = () => {
    const { chatJsUrl, chatCssUrl } = useAppSelector(pick(['chatJsUrl', 'chatCssUrl']));
    const [isLoaded, setIsLoaded] = useState(Boolean(window.Communication));
    const { enableChat, enableInbox } = useIsWidgetsEnabled();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    useEffect(() => {
        if (!enableChat && !enableInbox || !isLoggedIn || window.Communication) {
            return;
        }

        Promise.all([
            getScript(chatJsUrl),
            getStylesheet(chatCssUrl)
        ]).then(() => setIsLoaded(true));
    }, [enableChat, enableInbox, chatJsUrl, chatCssUrl, isLoggedIn]);

    return isLoaded;
};
